// sanityClient.js
import { createClient } from "@sanity/client";
import { SanityImageSource } from "@sanity/image-url/lib/types/types";
import imageUrlBuilder from "@sanity/image-url";

const client = createClient({
  projectId: "9jyen1hx",
  dataset: "production",
  useCdn: true,
  apiVersion: "2023-07-01",
});

const { projectId, dataset } = client.config();
const urlFor = (source: SanityImageSource) =>
  projectId && dataset
    ? imageUrlBuilder({ projectId, dataset }).image(source)
    : null;

export default client;
export { urlFor };
